import { z } from 'zod'

export const trainerStorageExceptionResponseSchema = z.record(z.unknown())
export type TrainerStorageExceptionResponse = z.infer<typeof trainerStorageExceptionResponseSchema>
